import { combineReducers } from 'redux'

import entidades from './store'
import despesasPorOrgao from './despesasPorOrgao/store'
import despesasPorUnidade from './despesasPorUnidade/store'
import despesasPorRubrica from './despesasPorRubrica/store'
import despesasPorCredor from './despesasPorCredor/store'
import despesasPorEmpenho from './despesasPorEmpenho/store'
import detalhesEmpenho from './detalhesEmpenho/store'
import gruposContabeis from './gruposContabeis/store'
import receitaArrecadada from './receitaArrecadada/store'
import operacoesDespesas from './operacoesDespesas/store'
import consultaDiarias from './consultaDiarias/store'
import transfFinAdm from './transfFinAdm/store'
import detalhesTransfFinAdm from './detalhesTransfFinAdm/store'
import detalhamentoLancamentoTransfFinAdm from './detalhamentoLancamentoTransfFinAdm/store'
import consultaRemuneracao from './consultaRemuneracao/store'
import detalhesRemuneracao from './detalhesRemuneracao/store'
import consultaConvenioParceriaConcedido from './consultaConvenioParceriaConcedido/store'
import consultaConvenioParceriaRecebido from './consultaConvenioParceriaRecebido/store'
import detalhesRecursoConcedido from './detalhesRecursoConcedido/store'
import detalhesRecursoRecebido from './detalhesRecursoRecebido/store'
import consultaMetasEducacao from './consultaMetasEducacao/store'
import consultaOrdemCronologicaPagamento from './consultaOrdemCronologicaPagamento/store'
import detalhesOrdemCronologicaPagamento from './detalhesOrdemCronologicaPagamento/store'
import receitaDiaria from './receitaDiaria/store'
import detalhesMetasEducacaoOrgao from './detalhesMetasEducacaoOrgao/store'
import detalhesMetasEducacaoEmpenho from './detalhesMetasEducacaoEmpenho/store'
import detalhesMetasEducacaoLiquidacao from './detalhesMetasEducacaoLiquidacao/store'
import consultaEmpenhoCredor from './consultaEmpenhoCredor/store'
import detalhesReceitaDiaria from './detalhesReceitaDiaria/store'
import consultaPlanoAnualContratacoes from './consultaPlanoAnualContratacoes/store'
import detalhesPlanosAnuaisContratacoes from './detalhesPlanosAnuaisContratacoes/store'
import consultaDetalhamentoDespesas from './consultaDetalhamentoDespesas/store'
import consultaRestosPagar from './consultaRestosPagar/store'
import consultaCreditoOrcamentarioReceitasProprias from './consultaCreditoOrcamentarioReceitasProprias/store'
import consultaFundosSaldosReceitas from './consultaFundosSaldosReceitas/store'
import consultaOrdemCronologicaPagamentoMP from './consultaOrdemCronologicaPagamentoMP/store'
import consultaDiariasPassagens from './consultaDiariasPassagens/store'
import consultaDespesasCartaoCorporativo from './consultaDespesasCartaoCorporativo/store'
import consultaPagamentoContraCheque from './consultaPagamentoContraCheque/store'
import consultaRepassesFundosInstitutosPrevidenciarios from './consultaRepassesFundosInstitutosPrevidenciarios/store'
import consultaDespesasPorAcaoOrcamentaria from './consultaDespesasPorAcaoOrcamentaria/store'
import consultaPlanoPlurianual from './consultaPlanoPlurianual/store'
import consultaConveniosInstrumentosCongeneres from './consultaConveniosInstrumentosCongeneres/store'
import detalhesDespesasCartaoCorporativo from './detalhesDespesasCartaoCorporativo/store'
import consultaPrestacaoContasAnual from './consultaPrestacaoContasAnual/store'
import detalhesAdiantamentosSuprimentos from './detalhesAdiantamentosSuprimentos/store'
import consultaAdiantamentosSuprimentos from './consultaAdiantamentosSuprimentos/store'
import consultaOrdensPagamentosExtraorcamentarias from './consultaOrdensPagamentosExtraorcamentarias/store'
import detalhesOrdensPagamentosExtraorcamentarias from './detalhesOrdensPagamentosExtraorcamentarias/store'
import consultaReceitasExtraorcamentarias from './consultaReceitasExtraorcamentarias/store'
import consultaEmpenhoCredorAquisicoesDiretas from './consultaEmpenhoCredorAquisicoesDiretas/store'
import despesasMensais from './despesasMensais/store'
import despesasMensaisPorFornecedor from './despesasMensaisPorFornecedor/store'
import detalhesPrestacao from './detalhesPrestacao/store'

export default combineReducers({
    entidades,
    despesasPorOrgao,
    despesasPorUnidade,
    despesasPorRubrica,
    despesasPorCredor,
    despesasPorEmpenho,
    gruposContabeis,
    receitaArrecadada,
    detalhesEmpenho,
    operacoesDespesas,
    consultaDiarias,
    transfFinAdm,
    detalhesTransfFinAdm,
    detalhamentoLancamentoTransfFinAdm,
    consultaRemuneracao,
    detalhesRemuneracao,
    consultaConvenioParceriaConcedido,
    consultaConvenioParceriaRecebido,
    detalhesRecursoConcedido,
    detalhesRecursoRecebido,
    consultaMetasEducacao,
    consultaOrdemCronologicaPagamento,
    detalhesOrdemCronologicaPagamento,
    receitaDiaria,
    detalhesMetasEducacaoOrgao,
    detalhesMetasEducacaoEmpenho,
    detalhesMetasEducacaoLiquidacao,
    consultaEmpenhoCredor,
    detalhesReceitaDiaria,
    consultaPlanoAnualContratacoes,
    detalhesPlanosAnuaisContratacoes,
    consultaDetalhamentoDespesas,
    consultaRestosPagar,
    consultaCreditoOrcamentarioReceitasProprias,
    consultaFundosSaldosReceitas,
    consultaOrdemCronologicaPagamentoMP,
    consultaDiariasPassagens,
    consultaDespesasCartaoCorporativo,
    consultaPagamentoContraCheque,
    consultaRepassesFundosInstitutosPrevidenciarios,
    consultaDespesasPorAcaoOrcamentaria,
    consultaPlanoPlurianual,
    consultaConveniosInstrumentosCongeneres,
    detalhesDespesasCartaoCorporativo,
    consultaPrestacaoContasAnual,
    detalhesAdiantamentosSuprimentos,
    consultaAdiantamentosSuprimentos,
    consultaOrdensPagamentosExtraorcamentarias,
    detalhesOrdensPagamentosExtraorcamentarias,
    consultaReceitasExtraorcamentarias,
    consultaEmpenhoCredorAquisicoesDiretas,
    despesasMensais,
    despesasMensaisPorFornecedor,
    detalhesPrestacao,
})
